import { If } from "../If/If";
import classes from "./SectionHeader.module.scss";
import { useNavigate } from "react-router-dom";

type SectionHeaderProps = {
  title: string | React.ReactNode;
  children?: React.ReactNode;
  showBackButton?: boolean;
};

export const SectionHeader = ({
  title,
  children,
  showBackButton = false,
}: SectionHeaderProps) => {
  const navigate = useNavigate();
  return (
    <div className={classes.header}>
      <h4>
        <If condition={showBackButton}>
          <button className={classes.backButton} onClick={() => navigate(-1)}>
            <i className="pi pi-angle-left"></i>
          </button>
        </If>
        {title}
      </h4>
      {children}
    </div>
  );
};
